import './Me.css';
import adminPic from "../imgs/expert.svg";
import partnerPic from "../imgs/profile.svg";
import { useEffect, useState } from 'react';
import defaultPfp from "../imgs/defaultPfp.svg";
import exit from "../imgs/exit_green.svg";
import { useOutletContext } from "react-router-dom";

export default function Me() {
    const login = localStorage.getItem("login");
    const me = JSON.parse(localStorage.getItem("me"));
    const role = me?.userInfo?.role;
    const name = me?.userInfo?.name;
    const created = new Date(me.userInfo.created_at);
    const createdAt = created.toISOString().split('T')[0];
    const email = me?.userInfo?.email;
    const phoneNumber = me?.userInfo?.phoneNumber;
    const partnerName = me?.userInfo?.partnerName;

    const [customPfpLink, setCustomPfpLinnk] = useState("");

    const { setOpenExitModal } = useOutletContext();
    
    useEffect(() => {
        document.title = "Личный кабинет - Wave";
    }, []);

    if (!me) return <div>Загрузка...</div>;

    return (
        <div className='meWrapper'>
            <h1>Личный кабинет</h1>
            <div className='profileCard'>
                <div className='information'>
                    <div className='profilePictureContainer'>
                        <img src={customPfpLink ? customPfpLink : defaultPfp} />
                    </div>
                    <div className='nameUsernameDate'>
                        <h2>{name}</h2>
                        <p className='login'>@{login}</p>
                        <p className='joined'>Дата присоединения: {createdAt}</p>
                    </div>
                    <div className='roleEmailPhone'>
                        <div className='keyValue'>
                            <p className='key'>Роль</p>
                            <p className='value'>{role}</p>
                        </div>
                        <div className='keyValue'>
                            <p className='key'>Email</p>
                            <p className='value'>{email}</p>
                        </div>
                        <div className='keyValue'>
                            <p className='key'>Номер телефона</p>
                            <p className='value'>{phoneNumber}</p>
                        </div>
                        {role === "Партнер" &&
                        <div className='keyValue partnerInfo'>
                            <p className='key'>Партнер</p>
                            <p className='value'>{partnerName ? partnerName : "Отсутствует"}</p>
                        </div>
                        }
                    </div>
                </div>
                <div className="exitBlock">
                    <button className='profileExit' onClick={() => setOpenExitModal(true)}><p>Выйти</p><img src={exit} /></button>
                </div>
            </div>
        </div>
    )
}